// src/context/BrandContext.jsx
import { createContext, useContext } from "react";

export const BrandContext = createContext(null);

export function usePublicBrand() {
  return useContext(BrandContext);
}
